import { personalInfoData } from '../data/personalInfo';

export default function projects(state = personalInfoData, action) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/personalInfo.js